export default __webpack_public_path__ + "ae853897d074372f7324582206d2d07e.svg";